<template>
  <router-view v-if="isRouterAlive" />
</template>
<script>
const env = process.env.NODE_ENV
if (env == 'production') {
  //百度统计
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?b8d5c86998083ff43f66250aaa3450cf";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}
// if (env != 'production') {
//   //google sdk
// }
  // (function() {
  //   var gm = document.createElement("script");
  //   gm.src = "https://accounts.google.com/gsi/client"
  //   var sg = document.getElementsByTagName("script")[0];
  //   sg.parentNode.insertBefore(gm, sg);
  // })();

export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true
    };
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  created() {
    this.changeLang(navigator.language)
  },
  methods: {
    changeLang(e) {
      let domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.NODE_DOMAIN;
      // this.$store.state.webConfig.lag = e;
      if (!this.$cookie.get('CardLang')) {
        var data = 'en'
        var navlanguage = e.toLowerCase()
        if (navlanguage.indexOf('ko') > -1) {
          data = 'ko'
        }
        if (navlanguage.indexOf('zh') > -1) {
          data = 'zh-tw'
        }
        this.$i18n.locale = data;
        this.$store.state.lang = data;
        this.$cookie.set('CardLang', data, {
          // expires: this.$store.state.exdays, 
          domain
        });

        this.reload()
      }
      // this.$nextTick(() => location.reload());
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
};

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue